import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './redux/store';
import App from './App';
import './index.css';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);

// TEMPORAIREMENT DÉSACTIVÉ: Le service worker bloque les headers d'authentification
// TODO: Réactiver après avoir corrigé le service worker pour qu'il skip les requêtes API
serviceWorkerRegistration.unregister();

// Enregistrer le service worker pour PWA
/*serviceWorkerRegistration.register({
  onSuccess: (registration) => {
    console.log('✅ PWA prête pour une utilisation hors ligne');
  },
  onUpdate: (registration) => {
    console.log('🔄 Nouvelle version disponible');
    // Afficher une notification à l'utilisateur
    const update = window.confirm(
      'Une nouvelle version de l\'application est disponible. Voulez-vous mettre à jour maintenant ?'
    );
    if (update && registration.waiting) {
      registration.waiting.postMessage({ type: 'SKIP_WAITING' });
      window.location.reload();
    }
  }
});*/
